import { createAction } from 'redux-actions';

export const createRolePolicy = createAction('CREATE_ROLE_POLICY');
export const createRolePolicySuccess = createAction('CREATE_ROLE_POLICY_SUCCESS');
export const createRolePolicyFailure = createAction('CREATE_ROLE_POLICY_FAILURE');

export const updateRolePolicy = createAction('UPDATE_ROLE_POLICY');
export const updateRolePolicySuccess = createAction('UPDATE_ROLE_POLICY_SUCCESS');
export const updateRolePolicyFailure = createAction('UPDATE_ROLE_POLICY_FAILURE');

export const deleteRolePolicy = createAction('DELETE_ROLE_POLICY');
export const deleteRolePolicySuccess = createAction('DELETE_ROLE_POLICY_SUCCESS');
export const deleteRolePolicyFailure = createAction('DELETE_ROLE_POLICY_FAILURE');
